export default {
    instagram: /instagram/i
}


// WEBPACK FOOTER //
// ./common/js/lib/UserAgentConstants.js